import { render, staticRenderFns } from "./FooterModular.vue?vue&type=template&id=6dc49d51&scoped=true&"
import script from "./FooterModular.vue?vue&type=script&lang=js&"
export * from "./FooterModular.vue?vue&type=script&lang=js&"
import style0 from "./FooterModular.vue?vue&type=style&index=0&id=6dc49d51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc49d51",
  null
  
)

export default component.exports